import { jsx } from "react/jsx-runtime";
import { Rating } from "@nxt-costco-com/forge-components";
import { CostcoBox } from "../../../Util/CostcoBox.js";
function FeatureRating({
  id,
  rating
}) {
  if (!rating) {
    return null;
  }
  return /* @__PURE__ */ jsx(CostcoBox, { sx: { margin: "0 8px" }, children: /* @__PURE__ */ jsx(
    Rating,
    {
      ariaLabel: `Rated ${rating} stars`,
      displayAvgRatingAsText: false,
      size: "small",
      uniqueId: id,
      value: rating
    }
  ) });
}
export {
  FeatureRating
};
